import request from '@/util/request';
import qs from 'qs';

export const getActionList = (params, options) =>
  request.get('/api/v4ward/out/order/setting/action/page', Object.assign({}, options, { params }));

export const getActionDetail = (params, options) =>
  request.get('/api/v4ward/out/order/setting/action/detail', Object.assign({}, options, { params }));

export const removeAction = (params, options) =>
  request.post('/api/v4ward/out/order/setting/action/remove', qs.stringify(params),options);

export const addAction = (params, options) =>
  request.post('/api/v4ward/out/order/setting/action/submit', params,options);

export const updateAction = (params, options) =>
  request.post('/api/v4ward/out/order/setting/action/submit', params,options);

export const availableActionList = (params, options) =>
  request.get('/api/v4ward/out/order/setting/action/availableActionList', Object.assign({}, options, { params }));

export const getTemplateList = (params, options) =>
  request.get('/api/v4ward/out/order/setting/remarktemplate/all', Object.assign({}, options, { params }));

export const getTemplateDetail = (params, options) =>
  request.get('/api/v4ward/out/order/setting/remarktemplate/detail', Object.assign({}, options, { params }));

export const removeTemplate = (params, options) =>
  request.post('/api/v4ward/out/order/setting/remarktemplate/remove', qs.stringify(params),options);

export const addTemplate = (params, options) =>
  request.post('/api/v4ward/out/order/setting/remarktemplate/save', params,options);

export const updateTemplate = (params, options) =>
  request.post('/api/v4ward/out/order/setting/remarktemplate/update', params,options);

export const upTemplate = (params, options) =>
  request.post('/api/v4ward/out/order/setting/remarktemplate/up', qs.stringify(params),options);

export const downTemplate = (params, options) =>
  request.post('/api/v4ward/out/order/setting/remarktemplate/down', qs.stringify(params),options);

